module.exports = __webpack_public_path__ + "img/hg.6336bb27.png";